// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Carousel3d from 'vue-carousel-3d'
import * as api from './api/api'
import http from './api/http.js'
import store from '@/store/index.js'
import globalVariable from "./common/GlobalVariable";
import globalMethod from "./common/GlobalMethod";
import jwt_decode from "jwt-decode";

//公用样式文件
import 'styles/reset.css'
import 'styles/border.css'
import 'swiper/dist/css/swiper.css'
import 'styles/main.css'
import 'babel-polyfill'
import 'url-search-params-polyfill';
//字体图标
import 'styles/iconfonts/iconfont.css'
Vue.use(ElementUI);
Vue.prototype.$api = http.api;
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.http = http;
Vue.prototype.jwt_decode = jwt_decode;
Vue.prototype.$bti = http.api;
Vue.use(VueAwesomeSwiper);
Vue.use(Carousel3d);
Vue.prototype.$own = globalVariable;
Vue.prototype.$fun = globalMethod;
/* eslint-disable no-new */
Vue.prototype.$onWait=new Promise((reslove)=>{
  Vue.prototype.$reslove=reslove;
})
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  render: function (createElement) {
    if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) {
      window.addEventListener('hashchange', () => {
        var currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }, false)
    }
    return createElement(App);
  }
});





// WEBPACK FOOTER //
// ./src/main.js